/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import StudentsList from "./components/StudentsList";

const HatchwayPractice = () => {
  const [studentsData, setStudentsData] = useState([]);
  const url = "https://api.hatchways.io/assessment/students";

  useEffect(() => {
    fetch(url)
      .then(response => {
        if (response.status !== 200) {
          console.log(`Looks like there was a problem: ${response.status}`);
          return;
        }

        response.json().then(data => setStudentsData(data.students));
      })
      .catch(err => console.error(err));
  }, []);
  return (
    <div className="hatchway-app">
      <StudentsList studentsData={studentsData} />
    </div>
  );
};

export default HatchwayPractice;
